"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var button_1 = require("@ingka/button");
var Email = function (_a) {
    var contactLabel = _a.contactLabel, buttonLink = _a.buttonLink, storeOpened = _a.storeOpened, activateAnalytics = _a.activateAnalytics, ariaLabel = _a.ariaLabel, colorButton = _a.colorButton, buttonStyles = _a.buttonStyles;
    var disabledWebForm = !storeOpened || !window.openWebForm;
    var disabledUrl = !storeOpened || !buttonLink;
    var activateContactAndAnalystics = function () {
        activateAnalytics('Button');
        if (window.openWebForm)
            return window.openWebForm();
        return null;
    };
    return buttonLink ? ((0, jsx_runtime_1.jsx)(button_1.default, __assign({ "data-cy": "contactcard-button", "data-testid": "email-button", type: colorButton, "aria-label": ariaLabel, className: buttonStyles, disabled: disabledUrl }, (!disabledUrl ? { href: buttonLink } : {}), { children: contactLabel }))) : ((0, jsx_runtime_1.jsx)(button_1.default, { "data-cy": "contactcard-button", "data-testid": "email-button", type: colorButton, "aria-label": ariaLabel, className: buttonStyles, onClick: function () { return activateContactAndAnalystics(); }, disabled: disabledWebForm, children: contactLabel }));
};
exports.default = Email;
